module.exports = __webpack_public_path__ + "img/DEW.c1c978cc.svg";